"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactImageLoaderHoc = _interopRequireDefault(require("react-image-loader-hoc"));

var _styles = require("./styles");

var _helpers = require("./helpers");

var _constants = require("./constants");

var QRImage = (0, _reactImageLoaderHoc.default)(_styles.Image);

var QRCode = function QRCode(_ref) {
  var data = _ref.data,
      size = _ref.size,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["data", "size"]);
  return _react.default.createElement(_styles.QRCodeWrap, (0, _extends2.default)({
    size: size
  }, rest), _react.default.createElement(QRImage, {
    src: (0, _helpers.getQrImageSrc)(data, size),
    size: size
  }));
};

QRCode.propTypes = {
  data: _propTypes.default.string,
  size: _propTypes.default.number
};
QRCode.defaultProps = {
  data: null,
  size: _constants.QR_DEFAULT_SIZE
};
var _default = QRCode;
exports.default = _default;